/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { unescapeHTML, titleize } from 'underscore.string';
import { Button, Checkbox, Glyphicon, OverlayTrigger, Popover, } from 'react-bootstrap';
import { withTranslation, useTranslation } from 'react-i18next';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import DataPoller from 'components/ui/DataPoller';
import CustomerStore from 'stores/CustomerSearchStore';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import CargomaticModal from 'components/v2/modal';
import CargomaticCard from 'components/v2/card';
import LabelValue from 'components/ui/tailwind/label-value';
import AccountContacts from 'components/v2/contacts';
import RecentActivity from 'components/modules/user/recent-activity';
import CommentList from 'components/modules/comments/CommentList';
import CarrierDriverWebAPIUtils from 'utils/CarrierDriverWebAPIUtils';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { Link } from 'react-router-dom';
import SessionStore from 'stores/SessionStore';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import ToastStore from 'stores/ToastStore';
import { REGIONS } from 'constants/Regions';
import { unescapeSpecialChars } from 'src/main/js/helpers/helper_functions';
import { createPhoneNumberWithExtension } from 'utils/formatters/Phone';
import CarrierForm from './carrier-form';
import BillingForm from './carrier-billing';
import AddDriverModal from './add-driver-modal';
import DriverList from './driver-list';
import CarrierAccountAccess from './CarrierAccountAccess';
import NotificationsManager from '../../notifications/manage-notifications';
import CarrierEDISettings from './carrier-edi-settings';
import Badge from '../../../v2/Badge';
import EditButton from '../../../v2/buttons/EditButton';
import Capability from '../Capability';
import WebhooksList from '../../webhooks/List';
import { getAddressString, hasAddress, } from '../../../../utils/transformers/AddressTransformer';
import { generateSensitiveDocumentLinks } from '../../../../utils/UserWebAPIUtils';
import { Avatar } from '../Avatar';
import AdminCarrierDetails from './admin-carrier-details';
const POLLING_FREQ = 10000;
const STATUSES = { AWAITING_TRAINING: 'Awaiting Training', TRAINED: 'Trained' };
const STATUS_OPTIONS = ['Trained', 'MVP'];
const renderAddress = (address) => {
    const addressString = getAddressString(address);
    return React.createElement(LabelValue, { value: addressString, icon: "map-marker" });
};
const loginAs = async (grantorId) => {
    const admin = SessionStore.getUser();
    try {
        const user = await UserWebAPIUtils.loginAs(admin._id, grantorId).catch((err) => {
            ToastStore.getNotifications().push({
                title: 'Error',
                body: err,
                level: 'error',
            });
        });
        if (user) {
            window.location.href = '/';
        }
    }
    catch (err) {
        ToastStore.getNotifications().push({
            title: 'Error',
            body: err,
            level: 'error',
        });
    }
};
const CarrierAccountDetails = (props) => {
    const { t } = useTranslation();
    const { user: { name, _id, first_name, last_name, phone, phone_extension, email, address, authorized: authorization, has_flatbed_trucks, hazmat_certified, tsa_certified, is_owner_operator, is_dray, test, enterprise, preferred_carrier, status, mvp, bank_verified, }, verification: { isVerified, authorized, bankTransfer, documentAlert }, onOpenJobs, onOpenPassword, onOpenAccountRequest, handleStatusUpdates, hasLoginAsPermission, } = props;
    const checkStatus = (type) => {
        switch (type) {
            case 'Trained':
                return status === STATUSES.TRAINED;
            case 'MVP':
                return mvp;
            default:
        }
    };
    const renderStatus = () => {
        return (React.createElement("div", { className: "dropdown-filter-wrapper mb-4 flex justify-center" },
            React.createElement(OverlayTrigger, { className: "dropdown-filter-wrapper", rootClose: true, trigger: "click", placement: "bottom", overlay: renderStatusPopup() },
                React.createElement("div", null,
                    React.createElement(Button, { style: { outline: 'none' }, bsSize: "small" },
                        React.createElement("strong", null, t('STATUS')),
                        React.createElement(Glyphicon, { glyph: "chevron-down", className: "button-down-glyph" }))))));
    };
    const renderStatusPopup = () => {
        const isSupport = SessionStore.isSupport();
        return (React.createElement(Popover, { id: "carrier-status-popup" },
            React.createElement("ul", { className: "filter-dropdown-wrapper" }, STATUS_OPTIONS.map((type) => {
                return (React.createElement("li", { key: type },
                    React.createElement(Checkbox, { onChange: (e) => handleStatusUpdates(type, e.target.checked, _id), checked: checkStatus(type), disabled: type === 'Trained' && !isSupport }, t(type.toUpperCase()))));
            }))));
    };
    return (React.createElement("div", { className: "" },
        React.createElement(CargomaticCard, { className: "mb-6" },
            React.createElement("div", { className: "flex justify-center mb-2" },
                React.createElement(Avatar, { key: _id, userId: _id, className: "h-32 w-32 cursor-pointer rounded-full" })),
            React.createElement("div", { className: "relative w-min my-0 mx-auto" },
                React.createElement("h3", { className: "my-2 text-xl text-center text-grey-darker whitespace-nowrap" }, `${unescapeHTML(name)}`),
                mvp ? (React.createElement("img", { src: "/img/cargomatic-circle.png", className: "absolute -top-1 -right-4 w-4", alt: "MVP" })) : null),
            React.createElement("div", { className: "flex flex-wrap justify-center -mx-2" },
                React.createElement("div", { className: "flex-none px-2 mb-2" },
                    React.createElement(Badge, { color: "blue", size: "large", rounded: true }, titleize(t('CARRIER', { count: 1 })))),
                React.createElement("div", { className: "flex-none px-2 mb-2" },
                    React.createElement(Badge, { color: authorized === 'authorized' ? 'brand' : 'red', size: "large", rounded: true }, t(authorized.toUpperCase()))),
                React.createElement("div", { className: "flex-none px-2 mb-2" },
                    React.createElement(Badge, { color: isVerified === 'verified' ? 'brand' : 'red', size: "large", rounded: true }, t('COMPANY_REPRESENTATIVE', {
                        isVerified: t(isVerified.toUpperCase()),
                    }))),
                React.createElement("div", { className: "flex-none px-2 mb-2" },
                    React.createElement(Badge, { color: bankTransfer === 'enabled' ? 'brand' : 'red', size: "large", rounded: true }, t('BANK_TRANSFERS', {
                        bankTransfer: t(bankTransfer.toUpperCase()),
                    }))),
                isVerified === ' unverified' && (React.createElement("div", { className: "flex-none px-2 mb-2" },
                    React.createElement(Badge, { color: "red", size: "large", rounded: true }, documentAlert)))),
            React.createElement("div", { className: "flex justify-center mt-4" },
                React.createElement("button", { className: "button text-grey-darker px-2", onClick: onOpenJobs }, t('VIEW_JOBS')),
                React.createElement(Link, { className: "button text-grey-darker no-underline px-2", to: `/carrier-metrics/${_id}` }, t('VIEW_SCORECARD')),
                SessionStore.isSupport() && (React.createElement("button", { className: "button text-grey-darker px-2", onClick: () => loginAs(_id) }, t('LOG_IN_AS')))),
            renderStatus()),
        React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => props.onOpenModal('account'), className: "flex flex-wrap items-center justify-between" },
                React.createElement("h3", { className: "my-0" }, t('ACCOUNT')),
                React.createElement(EditButton, null))) },
            React.createElement(LabelValue, { value: `${unescapeSpecialChars(name)}`, icon: "home" }),
            React.createElement(LabelValue, { value: `${unescapeSpecialChars(first_name)} ${unescapeSpecialChars(last_name)}`, icon: "user" }),
            React.createElement(LabelValue, { value: createPhoneNumberWithExtension(phone, phone_extension, t('EXT')), icon: "phone" }),
            React.createElement(LabelValue, { value: `${email}`, icon: "envelope" }),
            React.createElement("hr", null),
            React.createElement("div", { className: "" },
                React.createElement("header", { onClick: () => props.onOpenModal('address'), className: "flex flex-wrap justify-between" },
                    React.createElement("h3", { className: "my-0" }, t('ADDRESS')),
                    React.createElement(EditButton, null)),
                React.createElement("div", { className: "mb-6" },
                    hasAddress(address) && renderAddress(address),
                    !hasAddress(address) && (React.createElement(LabelValue, { value: t('NO_ADDRESS_ON_FILE'), icon: "map-marker" }))))),
        React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => props.onOpenModal('capabilities'), className: "flex flex-wrap justify-between" },
                React.createElement("h3", { className: "my-0" }, t('CAPABILITIES')),
                React.createElement(EditButton, null))) },
            React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.US] },
                React.createElement(Capability, { label: t('BANK_VERIFIED'), checked: bank_verified })),
            React.createElement(Capability, { label: t('AUTHORIZED'), checked: authorization }),
            React.createElement(Capability, { label: t('ENTERPRISE_CARRIER'), checked: enterprise }),
            React.createElement(Capability, { label: t('PREFERRED_CARRIER'), checked: preferred_carrier }),
            React.createElement(Capability, { label: `${t('HAS_FLATBED_TRUCKS')} ?`, checked: has_flatbed_trucks }),
            React.createElement(Capability, { label: t('HAZMAT_CERTIFIED'), checked: hazmat_certified }),
            React.createElement(Capability, { label: t('TSA_CERTIFIED'), checked: tsa_certified }),
            React.createElement(Capability, { label: t('OWNER_OPERATOR'), checked: is_owner_operator }),
            React.createElement(Capability, { label: t('DRAY_OPERATOR'), checked: is_dray }),
            React.createElement(Capability, { label: t('TEST'), checked: test })),
        React.createElement("div", { className: "my-6" },
            React.createElement("button", { onClick: () => onOpenPassword(), className: "w-full button button-hollow-red" }, t('CHANGE_PASSWORD'))),
        SessionStore.isSupport() && !hasLoginAsPermission && (React.createElement("div", { className: "my-6" },
            React.createElement("button", { onClick: () => onOpenAccountRequest(), className: "w-full button button-green", disabled: !SessionStore.isSupport() }, t('REQUEST_PERMISSION_TO_LOGIN_AS'))))));
};
class CarrierDetails extends React.Component {
    constructor(props) {
        super(props);
        // eslint-disable-next-line react/no-arrow-function-lifecycle
        this.componentDidMount = async () => {
            CustomerStore.addAuditChangeListener(this.onAuditChange);
            this.setState({
                hasLoginAsPermission: await this.hasLoginAsPermission(),
            });
        };
        this.onAuditChange = () => {
            const audits = CustomerStore.getCustomerAudits();
            if (!_.isEqual(audits, this.state.audits)) {
                return this.setState({ audits });
            }
        };
        this.onSaveDetails = (data) => {
            this.props.onSaveDetails('Carrier', data);
        };
        this.getUserAudits = () => {
            CustomerActionCreators.fetchCustomerAudits(this.props.details._id);
        };
        this.handleAddDefaultDriver = () => {
            this.props.onAddDefaultDriver();
        };
        this.handleAddComment = (message) => {
            CarrierDriverWebAPIUtils.addDriverComment(this.props.details._id, message);
        };
        this.handleBankingInfoAccept = () => {
            let carrier = this.props.details;
            UserWebAPIUtils.updateBankingInfoStatus(carrier._id, carrier.stripe_verified_documents, true, '');
            this.onSaveDetails({ _id: carrier._id, all_banking_info_approved: true });
        };
        this.handleBankingInfoDecline = () => {
            let carrier = this.props.details;
            UserWebAPIUtils.updateBankingInfoStatus(carrier._id, carrier.stripe_verified_documents, false, '');
            this.onSaveDetails({ _id: carrier._id, all_banking_info_approved: false });
        };
        this.handleGetVerificationData = async () => {
            const details = this.props.details;
            const stripeVerifiedDocuments = details === null || details === void 0 ? void 0 : details.stripe_verified_documents;
            const sensitiveDocuments = details === null || details === void 0 ? void 0 : details.sensitive_documents;
            if ((sensitiveDocuments && sensitiveDocuments.length) ||
                (stripeVerifiedDocuments && stripeVerifiedDocuments.length)) {
                const verificationReports = await generateSensitiveDocumentLinks(details._id);
                this.setState({
                    sensitiveDocumentData: verificationReports.entity.results,
                });
            }
        };
        this.handleStatusUpdates = (type, value, _id) => {
            let update = { _id };
            switch (type) {
                case 'Trained':
                    update.status = value ? STATUSES.TRAINED : STATUSES.AWAITING_TRAINING;
                    break;
                case 'MVP':
                    update.mvp = value;
                    break;
                default:
            }
            CustomersAPIUtils.updateCarrier(update);
        };
        this.hasLegalEntityDocumentDue = (fieldsNeeded) => {
            return fieldsNeeded.indexOf('legal_entity.verification.document') >= -1;
        };
        this.hasDocumentDue = (requirements) => {
            const verificationFields = ['currently_due', 'eventually_due', 'past_due'];
            const verificationDoc = 'verification.document';
            const missingVerificationDocs = verificationFields.filter((field) => requirements[field] &&
                requirements[field].indexOf(verificationDoc) > -1);
            return missingVerificationDocs.length > 0;
        };
        this.state = {
            showModal: false,
            audits: [],
            hasLoginAsPermission: false,
            sensitiveDocumentData: [],
        };
    }
    componentWillUnmount() {
        CustomerStore.removeAuditChangeListener(this.onAuditChange);
    }
    async hasLoginAsPermission() {
        const { details: carrier } = this.props;
        const scopes = await UserWebAPIUtils.getUserContextGrantsByGrantee(carrier._id, ['login']);
        if (scopes === null || scopes === void 0 ? void 0 : scopes.login) {
            return true;
        }
        return false;
    }
    renderModalComponent() {
        const { details } = this.props;
        return (React.createElement(CarrierForm, { category: this.state.category, details: details, onSave: (data) => this.onSaveDetails(data) }));
    }
    onAddDriver(driverData) {
        this.props.onAddDriver(driverData);
    }
    render() {
        const { hasLoginAsPermission } = this.state;
        const details = this.props.details;
        let drivers = details.drivers || [];
        drivers = drivers.slice().sort((a, b) => {
            if (a.first_name && b.first_name)
                return a.first_name.toLowerCase() < b.first_name.toLowerCase() ? -1 : 1;
            return -1;
        });
        let authorized = 'unauthorized';
        if (details.authorized)
            authorized = 'authorized';
        let isVerified = 'unverified';
        let fieldsNeeded = 'no verification fields are needed';
        let requirements = {};
        if (details.bank_accounts && details.bank_accounts.capabilities) {
            const { transfers } = details.bank_accounts.capabilities;
            if (transfers && transfers === 'active') {
                isVerified = 'verified';
            }
        }
        if (details.stripe_verification) {
            fieldsNeeded = details.stripe_verification.fields_needed;
            requirements = details.stripe_verification.requirements;
        }
        let documentAlert = '';
        if ((isVerified === 'unverified' &&
            fieldsNeeded &&
            this.hasLegalEntityDocumentDue(fieldsNeeded)) ||
            (requirements && this.hasDocumentDue(requirements))) {
            documentAlert = 'Needs DL or Passport Document';
        }
        const bankCapabilities = details.bank_accounts && details.bank_accounts.capabilities;
        let bankTransfer = 'disabled';
        if ((bankCapabilities && bankCapabilities.transfers === 'active') ||
            details.stripe_transfers_enabled) {
            bankTransfer = 'enabled';
        }
        const { t } = this.props;
        const isAdmin = SessionStore.isAdmin();
        return isAdmin ? (React.createElement(AdminCarrierDetails, { onOpenJobs: this.props.onOpenJobs, onOpenPassword: this.props.onOpenPassword, onOpenAccountRequest: this.props.onOpenAccountRequest, carrier: details, onSaveDetails: this.props.onSaveDetails, t: this.props.t })) : (React.createElement("div", { className: "mx-auto my-16 sm:my-32 lg:my-16 max-w-screen-2xl" },
            React.createElement(DataPoller, { action: this.getUserAudits, frequency: POLLING_FREQ }),
            React.createElement("div", { className: "lg:grid lg:grid-cols-4 lg:gap-x-6" },
                React.createElement("div", { className: "lg:col-span-1" },
                    React.createElement("div", { className: "mb-6" },
                        React.createElement(CarrierAccountDetails, { user: details, verification: {
                                authorized,
                                isVerified,
                                bankTransfer,
                                documentAlert,
                            }, onOpenJobs: this.props.onOpenJobs, onOpenPassword: this.props.onOpenPassword, onOpenAccountRequest: this.props.onOpenAccountRequest, onOpenModal: (category) => {
                                this.setState({ showModal: true, category });
                            }, handleStatusUpdates: this.handleStatusUpdates, hasLoginAsPermission: hasLoginAsPermission }))),
                React.createElement("div", { className: "lg:col-span-3" },
                    React.createElement("div", { className: "lg:grid lg:grid-cols-2 lg:gap-4" },
                        React.createElement("div", { className: "mb-6" },
                            React.createElement("div", { className: "mb-6" },
                                React.createElement(RecentActivity, { email: details.email })),
                            React.createElement(CargomaticCard, { removeHorizontalPadding: true, removeVerticalPadding: true, header: () => (React.createElement("h3", { className: "my-0" }, t('ACCOUNT_DISCUSSION'))) },
                                React.createElement(CommentList, { comments: details.comments, onCommentAdd: this.handleAddComment, paginate: true }))),
                        React.createElement(CargomaticCard, { className: "mb-6 col-span-1", header: () => React.createElement("h3", { className: "my-0" }, t('AUDIT_HISTORY')) },
                            React.createElement(AuditHistory, { audits: this.state.audits, paginate: true }))),
                    React.createElement("div", { className: "lg:col-span-3" },
                        React.createElement("div", { className: "lg:grid lg:grid-cols-2 lg:gap-4" },
                            React.createElement(AccountContacts, { className: "mb-6", contacts: details.contacts, userId: details._id }),
                            React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                                React.createElement("div", { className: "mb-6 col-span-1" },
                                    React.createElement(BillingForm, { details: details, onSave: this.props.onSaveBankAccount, onSaveLegalEntity: this.props.onSaveLegalEntity, sensitiveDocumentData: this.state.sensitiveDocumentData, onHandleBankingInfoAccept: this.handleBankingInfoAccept, onHandleBankingInfoDecline: this.handleBankingInfoDecline, onGetVerificationData: this.handleGetVerificationData }))))),
                    React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                        React.createElement("div", { className: "lg:grid lg:grid-cols-3 lg:gap-6" },
                            React.createElement("div", { className: "mb-6 col-span-2" },
                                React.createElement(CarrierEDISettings, { carrier: details, onCustomerPreferencesChange: this.onSaveDetails })))),
                    React.createElement("div", { className: "lg:grid lg:grid-cols-3 lg:gap-6" },
                        React.createElement("div", { className: "mb-6 col-span-2" },
                            React.createElement(WebhooksList, { userId: details._id, accountType: details._type }))),
                    React.createElement("div", { className: "lg:grid lg:grid-cols-3 lg:gap-6" },
                        React.createElement("div", { className: "mb-6 col-span-2" },
                            React.createElement(CargomaticCard, { header: () => React.createElement("h3", { className: "my-0" }, t('PARTNER_ACCESS')), grayFooter: true },
                                React.createElement(CarrierAccountAccess, { carrier: details })))),
                    React.createElement(DriverList, { onAdd: () => this.setState({ showAddDriverModal: true }), onAddDefaultDriver: this.handleAddDefaultDriver, carrier: ((details.name[0] || '').toUpperCase() +
                            (details.name.slice(1) || '')).trim(), drivers: drivers, onUpdateDriver: this.props.onUpdateDriver, defaultDriver: details.default_driver ? details.default_driver._id : null, onMakeDefault: this.props.onMakeDefault }),
                    React.createElement(NotificationsManager, { userNotificationPreferences: details }))),
            React.createElement(AddDriverModal, { show: this.state.showAddDriverModal, onHide: () => this.setState({ showAddDriverModal: false }), onSave: this.onAddDriver }),
            this.state.showModal && (React.createElement(CargomaticModal, { show: true, onHide: () => this.setState({ showModal: false }), title: t('EDIT_ACCOUNT'), body: this.renderModalComponent(), footer: null, location: "middle" }))));
    }
}
CarrierDetails.propTypes = {
    onSaveDetails: PropTypes.func.isRequired,
    onAddDriver: PropTypes.func.isRequired,
    onOpenJobs: PropTypes.func.isRequired,
    onOpenPassword: PropTypes.func.isRequired,
    onSaveBankAccount: PropTypes.func.isRequired,
    onSaveLegalEntity: PropTypes.func,
    onUpdateDriver: PropTypes.func.isRequired,
    details: PropTypes.object.isRequired,
    onMakeDefault: PropTypes.func,
};
CarrierDetails.defaultProps = {
    onSaveLegalEntity: null,
};
export default withTranslation()(CarrierDetails);
